<template>
  <v-app id="wgu-app" data-app :class="{ 'wgu-app': true, 'wgu-app-embedded': isEmbedded }">

    <wgu-app-header :color="baseColor" />

    <v-content>
      <v-container id="ol-map-container" fluid fill-height style="padding: 0">
         <wgu-map :color="baseColor" />
      </v-container>
    </v-content>

    <template v-for="(moduleWin, index) in moduleWins">
      <component
        :is="moduleWin.type" :key="index" :ref="moduleWin.type"
        :color="baseColor"
        :draggable="moduleWin.draggable"
        :initPos="moduleWin.initPos"
    />
    </template>

    <v-footer :color="baseColor" class="white--text" app>
      <span class="wgu-footer-left" v-html="footerTextLeft"></span>
      <!-- <span class="wgu-footer-left">Powered by <a href="https://meggsimum.de/wegue/" target="_blank">Wegue</a></span> -->
      <v-spacer></v-spacer>
      <div class="wgu-footer-right">
        <span  v-html="footerText">{{footerText}} </span>
        <span v-if="showCopyrightYear" >&copy; {{ new Date().getFullYear() }}</span>
      </div>
      <!-- <span class="wgu-footer-right">{{footerText}} <span v-if="showCopyrightYear" >&copy; {{ new Date().getFullYear() }}</span></span> -->
    </v-footer>

  </v-app>
</template>

<script>
  import Vue from 'vue'
  import { WguEventBus } from './WguEventBus'
  import OlMap from './components/ol/Map'
  import AppHeader from './components/AppHeader'
  import AppLogo from './components/AppLogo'
  import MeasureWin from './components/measuretool/MeasureWin'
  import LayerListWin from './components/layerlist/LayerListWin'
  import InfoClickWin from './components/infoclick/InfoClickWin'
  import SauberPilotRegionsMap from './sauber-pilots/SauberPilotRegionsMap'

  export default {
    name: 'wgu-app',
    components: {
      'wgu-map': OlMap,
      'wgu-app-header': AppHeader,
      'wgu-app-logo': AppLogo,
      'wgu-measuretool-win': MeasureWin,
      'wgu-layerlist-win': LayerListWin,
      'wgu-infoclick-win': InfoClickWin
    },
    data () {
      return {
        isEmbedded: false,
        moduleWins: this.getModuleWinData(),
        footerTextLeft: Vue.prototype.$appConfig.footerTextLeft,
        footerText: Vue.prototype.$appConfig.footerText,
        showCopyrightYear: Vue.prototype.$appConfig.showCopyrightYear,
        baseColor: Vue.prototype.$appConfig.baseColor
      }
    },
    created () {
      // CM - 2019-02-14
      WguEventBus.$on('ol-map-mounted', (olMap) => {
        /* eslint-disable no-new */
        new SauberPilotRegionsMap(olMap);
      });
      // END CM - 2019-02-14
    },
    mounted () {
      // apply the isEmbedded state to the member var
      this.isEmbedded = this.$isEmbedded;

      // make the refs (floating module window, which are not connected to their
      // related components, e.g. buttons to toggle them)
      const refs = this.$refs;
      let cmpLookup = {};
      for (const key of Object.keys(refs)) {
        cmpLookup[key] = refs[key][0];
      }
      Vue.prototype.cmpLookup = cmpLookup;
      // inform registered cmps that the app is mounted and the dynamic
      // components are available
      WguEventBus.$emit('app-mounted');
    },
    methods: {
      /**
       * Determines the module window configuration objects from app-config:
       *     moduleWins: [
       *       {type: 'wgu-layerlist-win'},
       *       {type: 'wgu-measuretool-win'}
       *     ]
       * @return {Array} module window configuration objects
       */
      getModuleWinData () {
        const appConfig = Vue.prototype.$appConfig;
        let moduleWins = [];
        for (const key of Object.keys(appConfig.modules)) {
          const moduleOpts = appConfig.modules[key];
          if (moduleOpts.win === true) {
            moduleWins.push({
              type: key + '-win',
              draggable: moduleOpts.draggable,
              initPos: moduleOpts.initPos
            });
          }
        }
        return moduleWins;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/WguAppSauberPilots.vue